export default __webpack_public_path__ + "static/media/Collaboration.d9435d22.svg";